module.exports = __webpack_public_path__ + "static/media/casa.6b4e54ec.svg";